"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const ReplacesEnum_1 = require("../ReplacesEnum");
exports.Common = Object.freeze({
    EXTENSION_NAME: 'Omnito Meeting Booker: Seamless Scheduling',
    EXTENSION_SHORT_NAME: 'Omnito Inbox',
    EXTENSION_DESCRIPTION: "Simplify scheduling! In a click connect your calendar, set availability, and send invites to be sure you're never double booked.",
    EXTENSION_BUTTON_TOOLTIP: 'Insert Omnito Meeting Booker',
    AUTHORIZATION_SERVER_ONE: 'Omnito',
    AUTHORIZATION_SERVER_SALESFORCE: 'Omnito for Salesforce (CEP)',
    AUTHORIZATION_SERVER_SALESFORCE_PRODUCTION: 'Production',
    AUTHORIZATION_SERVER_SALESFORCE_SANDBOX: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_SUMO1_LOGIN_TITLE: 'Omnito',
    ACTIVE_TAB_SIDEBAR_SALESFORCE_LOGIN_TITLE: 'Omnito for Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_BUTTON: 'Login',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_GOOGLE_BUTTON: 'Login with Google',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_MICROSOFT_BUTTON: 'Login with Microsoft',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_BUTTON: 'Login with Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_PRODUCTION_BUTTON: 'Production',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_SANDBOX_BUTTON: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_TEXT: "Don't have an account?",
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_LINK: 'Sign Up',
    ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON: 'Create a Meeting',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN: 'Welcome, you are logged in.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN_CREATE_MEETING_BUTTON: 'Click Create a Meeting to add time slots to your email.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_1: "1. Open <a target='_blank' class='text-blue-100 no-underline' href='https://mail.google.com'>Gmail.com</a> or <a target='_blank' class='text-blue-100 no-underline' href='https://outlook.live.com'>Outlook.live.com</a> and create a new email",
    GMAIL_URL: 'gmail.com',
    OUTLOOK_URL: 'outlook.live.com',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_2: '2. Click on the Meeting Booker icon',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_3: '3. Make booking faster. Connect your contacts to speed up booking.',
    ACTIVE_TAB_SIDEBAR_ALLOW_CONTACTS_ACCESS_BUTTON: 'Allow access',
    SCHEDULER_CONNECT_CONTACTS_BANNER_TITLE: 'Make booking faster',
    SCHEDULER_CONNECT_CONTACTS_BANNER_DESCRIPTION: 'Connect your Google Contacts to quickly find people and autofill meeting details.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON: 'Log out',
    ACTIVE_TAB_SETTINGS_LOGOUT_BUTTON: 'Log out',
    SCHEDULER_DEFAULT_WORKSPACE_LABEL: 'Default Workspace',
    SCHEDULER_WORKSPACE_LABEL: 'Workspace',
    SCHEDULER_WORKSPACE_TOOLTIP: 'The list of services and hosts will update based on your selected workspace',
    SCHEDULER_SETTINGS_DEFAULT_PROCESS_LABEL: 'Default Process',
    SCHEDULER_SETTINGS_DEFAULT_HOST_LABEL: 'Default Host',
    SCHEDULER_SETTINGS_HOST_ME_LABEL: 'Me',
    SCHEDULER_SETTINGS_HOST_NONE_LABEL: 'None',
    SCHEDULER_SETTINGS_BUTTON: 'Settings',
    SCHEDULER_SETTINGS_TOOLTIP: 'Settings',
    SCHEDULER_MEETING_NAME_LABEL: 'Meeting Name',
    SCHEDULER_APPOINTMENT_TITLE_LABEL: 'Appointment Title / Type',
    SCHEDULER_APPOINTMENT_TYPES_LABEL: 'Appointment Types',
    SCHEDULER_APPOINTMENT_TYPES_PLACEHOLDER: 'Select appointment types',
    SCHEDULER_APPOINTMENT_TYPES_SEARCH_PLACEHOLDER: 'Search',
    SCHEDULER_APPOINTMENT_TYPES_MAX_WARNING: `Maximum ${ReplacesEnum_1.ReplacesDetailEnum.MAX} can be selected.`,
    SCHEDULER_APPOINTMENT_TITLE_ONLY_LABEL: 'Appointment Title',
    SCHEDULER_APPOINTMENT_TITLE_ONLY_PLACEHOLDER: 'Enter appointment title',
    SCHEDULER_TITLE_PLACEHOLDER: 'Enter name',
    SCHEDULER_MEETING_TYPE_LABEL: 'Meeting Type',
    SCHEDULER_MEETING_TYPES_LABEL: 'Meeting Types',
    SCHEDULER_TEMPLATE_PLACEHOLDER: 'Select',
    SCHEDULER_DURATION_LABEL: 'Duration',
    SCHEDULER_TOTAL_DURATION_LABEL: 'Total Duration',
    SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL: 'minutes',
    SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL: 'hours',
    SCHEDULER_DURATION_DIMENSION_MINUTES_SHORT_LABEL: 'min',
    SCHEDULER_DURATION_DIMENSION_HOURS_SHORT_LABEL: 'h',
    SCHEDULER_DURATION: 'duration',
    SCHEDULER_BUFFER: 'buffer',
    SCHEDULER_BUFFER_TIME_NONE_LABEL: 'None',
    SCHEDULER_BUFFER_TIME_MIN5_LABEL: '5 mins',
    SCHEDULER_BUFFER_TIME_MIN10_LABEL: '10 mins',
    SCHEDULER_BUFFER_TIME_MIN15_LABEL: '15 mins',
    SCHEDULER_BUFFER_TIME_MIN20_LABEL: '20 mins',
    SCHEDULER_BUFFER_TIME_MIN25_LABEL: '25 mins',
    SCHEDULER_BUFFER_TIME_MIN30_LABEL: '30 mins',
    SCHEDULER_BUFFER_TIME_MIN35_LABEL: '35 mins',
    SCHEDULER_BUFFER_TIME_MIN40_LABEL: '40 mins',
    SCHEDULER_BUFFER_TIME_MIN45_LABEL: '45 mins',
    SCHEDULER_BUFFER_TIME_MIN50_LABEL: '50 mins',
    SCHEDULER_BUFFER_TIME_MIN55_LABEL: '55 mins',
    SCHEDULER_BUFFER_TIME_MIN60_LABEL: '60 mins',
    SCHEDULER_BUFFER_LABEL: 'Buffer',
    SCHEDULER_BUFFER_TOOLTIP: "Block the host's calendar before and/or after this meeting for this duration. Buffer times are typically used for prep, debrief, or parking for in-person meetings.",
    SCHEDULER_BUFFER_BEFORE_LABEL: 'Before',
    SCHEDULER_BUFFER_AFTER_LABEL: 'After',
    SCHEDULER_LOCATION_LABEL: 'Location',
    SCHEDULER_LOCATION_VIDEO_CONFERENCE: 'Video Conf',
    SCHEDULER_LOCATION_IN_PERSON: 'In Person',
    SCHEDULER_LOCATION_PHONE: 'Phone',
    SCHEDULER_LOCATION_PHONE_HOST_PHONE: 'Host',
    SCHEDULER_LOCATION_PHONE_INVITEE_PHONE: 'Invitee',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE: 'Custom',
    SCHEDULER_LOCATION_INTEGRATION_ENABLED_LABEL: 'Include video conference details',
    SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL: 'Zoom',
    SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL: 'Google meet',
    SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL: 'Microsoft teams',
    SCHEDULER_LOCATION_PHYSICAL_ADDRESS_PLACEHOLDER: 'Choose address',
    SCHEDULER_LOCATION_ROOM_PLACEHOLDER: 'Room',
    SCHEDULER_LOCATION_RESOURCES_PLACEHOLDER: 'Resources',
    SCHEDULER_LOCATION_CUSTOM_ADDRESS_PLACEHOLDER: 'Enter custom address',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PLACEHOLDER: 'Enter phone number',
    SCHEDULER_LOCATION_IN_PERSON_LOCATION: 'Organization Locations',
    SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS: 'Custom Address',
    SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION: 'Invitee Location',
    SCHEDULER_AVAILABILITY_LABEL: 'Availability',
    SCHEDULER_AVAILABILITY_TOOLTIP: 'Open mode will offer the most available date/time slots to the main guest. The additional options (custom, rolling window, date range) allow you to limit the available slots.',
    SCHEDULER_AVAILABILITY_OPEN: 'Open',
    SCHEDULER_AVAILABILITY_CUSTOM: 'Custom',
    SCHEDULER_AVAILABILITY_ROLLING: 'Rolling',
    SCHEDULER_AVAILABILITY_RANGE: 'Range',
    SCHEDULER_AVAILABILITY_OPEN_DESCRIPTION: 'This meeting may be scheduled at any available date or time, starting from when the attendee clicks the invite link.',
    SCHEDULER_AVAILABILITY_CUSTOM_DESCRIPTION: 'On the calendar you may draw your custom availability for this invite. Attenders will be only offered times you designate as available.',
    SCHEDULER_AVAILABILITY_ROLLING_DESCRIPTION: 'Attenders will be offered available times during a period starting from when they click on the invitation link.',
    SCHEDULER_AVAILABILITY_ROLLING_WINDOW_LABEL: 'Window (days)',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_LABEL: 'Expires',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_PLACEHOLDER: 'Never',
    SCHEDULER_AVAILABILITY_RANGE_DESCRIPTION: 'Select a date range of availability to offer.',
    SCHEDULER_AVAILABILITY_RANGE_START_LABEL: 'Start',
    SCHEDULER_AVAILABILITY_RANGE_START_DATE_PLACEHOLDER: 'Start date',
    SCHEDULER_AVAILABILITY_RANGE_START_TIME_PLACEHOLDER: 'Start time',
    SCHEDULER_AVAILABILITY_RANGE_END_LABEL: 'End',
    SCHEDULER_AVAILABILITY_RANGE_END_DATE_PLACEHOLDER: 'End date',
    SCHEDULER_AVAILABILITY_RANGE_END_TIME_PLACEHOLDER: 'End time',
    SCHEDULER_LIMIT_LABEL: 'Limit',
    SCHEDULER_LIMIT_TOOLTIP: 'Limit the # of appointments that may be booked with this invite / link. After this limit is met, this invite/link will be auto-expired.',
    SCHEDULER_LIMIT_LIMIT1_LABEL: '1',
    SCHEDULER_LIMIT_LIMIT2_LABEL: '2',
    SCHEDULER_LIMIT_LIMIT3_LABEL: '3',
    SCHEDULER_LIMIT_LIMIT4_LABEL: '4',
    SCHEDULER_LIMIT_LIMIT5_LABEL: '5',
    SCHEDULER_LIMIT_LIMIT6_LABEL: '6',
    SCHEDULER_LIMIT_LIMIT7_LABEL: '7',
    SCHEDULER_LIMIT_LIMIT8_LABEL: '8',
    SCHEDULER_LIMIT_LIMIT9_LABEL: '9',
    SCHEDULER_LIMIT_LIMIT10_LABEL: '10',
    SCHEDULER_LIMIT_UNLIMITED_LABEL: 'Unlimited',
    SCHEDULER_HOST_LABEL: 'Host',
    SCHEDULER_HOST_PLACEHOLDER: 'Add host',
    SCHEDULER_ADD_GUEST_LABEL: 'Add Attendees',
    SCHEDULER_ADD_GUEST_PLACEHOLDER: 'Search by name or email',
    SCHEDULER_MAIN_GUEST_LABEL: 'Invitee',
    SCHEDULER_NOTE_LABEL: 'Note for invitee and attendees',
    SCHEDULER_MAIN_GUEST_TOOLTIP: 'If the invitee is defined, click "Insert Slots & Close" to add time slots to the email. Otherwise, click "Copy Link & Close" to send to anyone, and the invitee can identify themselves upon booking.',
    SCHEDULER_MAIN_GUEST_PLACEHOLDER: 'Search by name or email',
    SCHEDULER_GUESTS_LABEL: 'Attendees',
    SCHEDULER_DESCRIPTION_LABEL: 'Note from Host',
    SCHEDULER_INSERT_BUTTON_LABEL: 'Insert Slots & Close',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_LABEL: 'Book & close',
    SCHEDULER_BOOK_AND_NEW_BUTTON_LABEL: 'Book & new',
    SCHEDULER_INSERT_BUTTON_TOOLTIP: 'Will insert available time slots into your email.',
    SCHEDULER_BOOK_AND_NEW_BUTTON_TOOLTIP: 'Books appointment right away and resets for a new booking.',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_TOOLTIP: 'Books appointment right away and closes the Meeting Booker.',
    SCHEDULER_COPY_LINK_BUTTON_LABEL: 'Copy Link & Close',
    SCHEDULER_COPY_LINK_BUTTON_TOOLTIP: 'Will copy this booking link, which you may paste into an email.',
    SCHEDULER_BUTTON_PREVIOUS_WEEK: 'Previous week',
    SCHEDULER_BUTTON_NEXT_WEEK: 'Next week',
    SCHEDULER_BUTTON_THIS_WEEK: 'This week',
    SCHEDULER_BUTTON_TODAY: 'today',
    SCHEDULER_ERROR: 'Error',
    INTERNAL_SERVER_ERROR: 'Internal Server Error',
    INTERNAL_SERVER_ERROR_ALERT: 'The opening is WHITE will be inserted into the invite.',
    SCHEDULER_CREATE_BOOKING_PAGE_ERROR: 'CreateBookingPage request failed. Please try again later',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR: 'Upgrade your plan, as you have hit the limit.',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK: 'Explore Plans',
    SCHEDULER_MEMBERS_ERROR: 'Members request failed. Please try again later',
    SCHEDULER_TEMPLATE_ERROR: 'Templates request failed. Please try again later',
    GET_USER_LOGIN_ERROR_MESSAGE: 'No account exists with such email',
    GET_USER_AUTH_ERROR_MESSAGE: 'User login request fail',
    GET_USER_LOGOUT_ERROR_MESSAGE: 'User logout request fail',
    DELETE_USER_SUCCESS_MESSAGE: 'Authentication request fail',
    DELETE_USER_ERROR_MESSAGE: 'Delete user request fail',
    CHOOSE_AN_ACCOUNT_ERROR_TOAST: 'Choose an account fail',
    GET_MAIN_DATA_ERROR_MESSAGE: 'Authentication request fail',
    ROLE_DEACTIVATED_ERROR_MESSAGE: 'Role has been deactivated.  Please contact your Omnito administrator.',
    USER_DEACTIVATED_ERROR_MESSAGE: 'User has been deactivated.  Please contact your Omnito administrator.',
    TRIAL_LIMIT_ERROR_MESSAGE: 'You have exceeded the limit of 40 items for the Trial version',
    ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE: 'Another account already associated with this email',
    DELETE_ROLE_ASSIGNED_ERROR_MESSAGE: 'Can not be deleted. Users are assigned to this role.',
    INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE: 'Invalid Google API key or required services are not enabled.',
    IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE: 'Import failed: Limit of 100 locations exceeded. Please split your file.',
    PRICING_TIER_ACCESS_EXCEPTION_MESSAGE: 'Please upgrade your Subscription Plan to access this feature.',
    RESEND_USER_INVITE_ERROR_MESSAGE: 'Admin data record with this email already created for this org',
    ACTIVE_TAB_SIDEBAR_LICENSE_ERROR: 'Your license is expired. Please check your subscription.',
    PLEASE_WAIT_AND_TRY_AGAIN: 'Please wait and try again',
    FAILED_TO_LOAD_SCHEDULER_DATA: 'Failed to load scheduler data...',
    MEETING_BOOKER_INSTALLED: 'Meeting Booker is installed.',
    TRY_AGAIN: 'Try Again',
    SPOTS_WIDGET_CLICK_HERE: 'Click here',
    SPOTS_WIDGET_VIEW_MORE_OPTIONS: 'to view more options',
    SPOTS_WIDGET_SELECT_TIME_SLOT: 'to select available time slot',
    SCHEDULER_COPY_LINK: 'Copy Link',
    SCHEDULER_ADD_INVITEE: 'Add invitee',
    SCHEDULER_ADD_ATTENDEE: 'Add attendee',
    SEARCH_ATTENDEE_PLACEHOLDER: 'Search or type to add attendee',
    SEARCH_HOST_PLACEHOLDER: 'Search or type to select host',
    SHOW_WEEKENDS: 'Show weekends',
    INVITEE_AMD_ATTENDEES: 'Invitee and attendees',
    SCHEDULER_BOOKING_TOOLS: 'Booking Tools',
    SCHEDULER_USER_SETTINGS: 'User Settings',
    SCHEDULER_ALL_PERSONAL_LINKS: 'All Personal Links',
    SCHEDULER_TOOLS: 'Tools',
    SCHEDULER_TEMPLATES: 'Templates',
    SCHEDULER_TOOLS_AVAILABILITY: 'Availability',
    SCHEDULER_TOOLS_INTEGRATE: 'Integrations',
    SCHEDULER_TOOLS_BOOKING_PAGES: 'Meeting Types',
    SCHEDULER_TOOLS_MY_BOOKING_PAGES: 'My Meeting Types',
    SCHEDULER_TOOLS_SHARED_BOOKING_PAGES: 'Shared Meeting Types',
    SCHEDULER_HEADER_TAB_1: 'Offer booking time',
    SCHEDULER_HEADER_TAB_2: 'Instant meeting',
    SCHEDULER_DEFAULT_INVITEE_NAME_LABEL: 'Name',
    SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL: 'Email',
    SCHEDULER_GUIDE_TITLE: 'Welcome to Meeting Booker',
    SCHEDULER_ONBOARDING: 'Start on-boarding',
    SCHEDULER_SKIP: 'Skip',
    SCHEDULER_GUIDE_DESCRIPTION: 'Effortlessly schedule meetings — right from your email. Pick your availability, insert time slots into your message, and let others choose what works best.',
    SCHEDULER_GUIDE_HOW_IT_WORKS: 'How it works',
    SCHEDULER_GUIDE_STEP_1_TITLE: 'Step 1: Sign in or create your account',
    SCHEDULER_GUIDE_STEP_1_DESCRIPTION: 'Use your email to sign in or quickly create a new account to get started with Meeting Booker.',
    SCHEDULER_GUIDE_STEP_2_TITLE: 'Step 2: Start a new email',
    SCHEDULER_GUIDE_STEP_2_DESCRIPTION: 'Compose a email, and click the Meeting Booker icon in the toolbar.',
    SCHEDULER_GUIDE_STEP_3_TITLE: 'Step 3: Set up your meeting',
    SCHEDULER_GUIDE_STEP_3_DESCRIPTION: 'Pick duration, meeting type, time slots, invitees, and add a note — all synced with your calendar.',
    SCHEDULER_GUIDE_STEP_4_TITLE: 'Step 4: Insert time slots into your email',
    SCHEDULER_GUIDE_STEP_4_DESCRIPTION: 'Click “Insert Slots & Close” — we’ll add your availability right into the message. Send it and let them choose!',
    SCHEDULER_GUIDE_GET_STARTED_BUTTON: 'Get Started',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE: "You're booked!",
    SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX: 'Check your inbox for an email with all the details.',
    SCHEDULER_BOOKED_ERROR_MESSAGE: 'Time Slot Required',
    SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT: 'Please pick a time slot from the calendar to book your meeting.',
    CHARACTER_LIMIT_REACHED: 'Limit reached',
    SCHEDULER_TIME_SLOT_TO_SHORT_TITLE: 'Please pick larger time slot from the calendar.',
    SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION: `This time slot is too short. Your meeting requires ${ReplacesEnum_1.ReplacesDetailEnum.DURATION}.`,
    SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE: 'Timezone Not Selected',
    SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION: 'Please select a timezone from the calendar dropdown before inserting time slots.',
    NO_ACTIVE_WORKSPACES_TITLE: 'No Active Workspaces',
    NO_ACTIVE_WORKSPACES: "There are no active workspaces at the moment. We're sure this will be sorted out soon—check back later or contact your administrator.",
    WEEKDAYS_ONLY: 'Weekdays Only',
    INCLUDE_WEEKENDS: 'Include Weekends',
    SUCCESS: 'Success',
    ERROR: 'Error',
    INFO: 'Info',
    WARNING: 'Warning',
    CALENDAR_DISPLAY: 'Calendar Display',
    MY_BOOKING_PAGES: 'My Meeting Types',
    SHARED_BOOKING_PAGES: 'Shared Meeting Types',
    SCHEDULER_MY_MEETINGS_LABEL: 'My Meetings',
    SCHEDULER_SHARED_MEETINGS_LABEL: 'Shared with me',
    SCHEDULER_TEAM_LABEL: 'Team',
    SCHEDULER_ROUND_ROBIN_LABEL: 'Round-Robin',
    SCHEDULER_POOL_LABEL: 'Pool',
    SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS: 'User does not have necessary permissions',
    CORS_CONFIGURATION_REQUIRED_TITLE: 'CORS Configuration Required',
    CORS_CONFIGURATION_REQUIRED_TEXT: 'Access to user information is blocked by Salesforce CORS settings. Contact your Salesforce administrator to resolve this issue.',
    GMAIL_CONTACTS_TOOLTIP: 'Gmail Contacts',
    OUTLOOK_CONTACTS_TOOLTIP: 'Outlook Contacts',
    SALESFORCE_TOOLTIP: 'Salesforce',
    SALESFORCE_LEAD_TOOLTIP: 'Lead',
    SALESFORCE_CONTACT_TOOLTIP: 'Contact',
    SALESFORCE_PERSON_ACCOUNT_TOOLTIP: 'Person Account',
    SALESFORCE_TEAM_TOOLTIP: 'Team',
    SALESFORCE_RESOURCE_TOOLTIP: 'Resource',
    SALESFORCE_BUCKET_TOOLTIP: 'Bucket',
    SALESFORCE_USER_TOOLTIP: 'User',
    HUBSPOT_TOOLTIP: 'HubSpot',
    SUMO_FOR_SALESFORCE_CEP_TOOLTIP: 'Omnito for Salesforce (CEP)',
    SERVICE_NOW_TOOLTIP: 'ServiceNow',
    SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL: 'Minimum Notice Period',
    SCHEDULER_DURATION_WARNING: 'Warning: Total duration is shorter than selected services.',
    SCHEDULER_HOST_LIMIT_WARNING: 'The currently selected host has exceeded their personal limit of appointments for the selected Appointment Type.',
    SCHEDULER_BUSY: 'Busy',
    // Login Page
    LOGIN_OR: 'or',
    LOGIN_CONTINUE: 'Continue',
    LOGIN_EMAIL_PLACEHOLDER: 'Email',
    LOGIN_PASSWORD_LABEL: 'Password',
    LOGIN_BACK: 'Back',
    LOGIN_BUTTON: 'Login',
    LOGIN_FORGOT_PASSWORD: 'I forgot my password.',
    LOGIN_SEND_RECOVERY_EMAIL: 'Send recovery email.',
    FORGOT_PASSWORD_SUCCESS_MESSAGE: 'Recovery email sent! Check your inbox for a link to reset your password.',
    LOGIN_INVALID_PASSWORD: 'Invalid password.',
    LOGIN_INVALID_EMAIL: 'Invalid email address.',
    LOGIN_NO_ACCOUNT: "No account exists with this email.",
    // MFA (TOTP)
    MFA_TITLE: 'Two-Factor Authentication',
    MFA_SUBTITLE: 'Enter the 6-digit code from your authenticator app.',
    MFA_VERIFY: 'Verify',
    MFA_SAVE_THIS_DEVICE: 'Save this device',
    MFA_INCORRECT_CODE: 'Incorrect code. Please try again.',
});
